/* eslint-disable no-useless-escape */
/*
 * @Author: DQL
 * @Date: 2020-03-09 17:47:35
 * @LastEditors: DQL
 * @LastEditTime: 2022-03-31 14:55:56
 * @Description: file content
 */
const banner = `
========================================================================
  _   _   __  __     
 | | | | |  \/  |    
 | |_| | | |\/| |  
 |  _  | | |  | |  _        ------------------------------------------
 |_| |_| |_|  |_| (_)       |   static resource kestrel-portal(鸿蒙门户) |
                            ------------------------------------------
 Copyright ©2022 鸿蒙科技, All Rights Reserved
=========================================================================
`;

console.log(banner);
